import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M28.9 3.533c1.113 1.269 1.722 2.667 2.02 3.534H18V3.533zm2.792 7.2c.163 1.199.253 2.387.289 3.534H18v-3.534zm-30.613-3.6H18v3.534H.34c.131-.925.305-1.86.526-2.792 0 0 .06-.285.213-.742",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10.867.291V18H7.333V.913C8.324.647 9.538.44 10.868.291",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.026 17.933H31.97a34 34 0 0 1-.329 3.534H.345a33 33 0 0 1-.319-3.534m1.146 7.2h29.656c-.332.914-.974 2.3-2.112 3.534H3.284c-1.138-1.234-1.78-2.62-2.112-3.534",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagGrc = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagGrc_default = SvgFlagGrc;

export { FlagGrc_default as default };
